import { render } from "./categorylist.vue?vue&type=template&id=554570c2&scoped=true"
import script from "./categorylist.vue?vue&type=script&lang=js"
export * from "./categorylist.vue?vue&type=script&lang=js"

import "./categorylist.vue?vue&type=style&index=0&id=554570c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554570c2"]])

export default __exports__